// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles-module__badge___4k40z","clickable":"styles-module__clickable___3XrUU"};